import { FormAtylRestriction } from './form-atyl-restriction'
import {  EventEmitter, Output } from '@angular/core'
import { Injectable } from '@angular/core'

export class FormAtylBase<T> {
	ID: any
	value: T
	key: string
	label: string
	description: string
	options: any
	optionsDefault: any
	restrictions: FormAtylRestriction<T>[]
	order: number
	controlType: string
	structureType: string
	customBehaviour: string
	children: FormAtylBase<T>[]
	deepNested: string
	placeholder: string
	floatlabel: string
	type: string
	mendatory: boolean
	complementary?: any
	observe?: boolean
	observe_champ?: number
	historique?: boolean
    readonly?: boolean
    hideCreate?: boolean  
	dossier:any
	tiers:any
	
	constructor(options: {
		ID?: any,
		value?: T,
		key?: string,
		label?: string,
		description?: string,
		options?: any,
		optionsDefault?: any,
		restrictions?: FormAtylRestriction<T>[],
		order?: number,
		controlType?: string,
		structureType?: string,
		customBehaviour?: string,
		children?: FormAtylBase<T>[],
		deepNested?: string,
		placeholder?: string,
		floatlabel?: string,
		type?: string,
		mendatory?: boolean,
		complementary?: any,
		observe?: boolean,
		observe_champ?: number,
		historique?: boolean,
		readonly?: boolean,
		hideCreate?: boolean,
		
	} = {}) {
		this.ID = options.ID || ''
		this.value = options.value
		this.key = options.key || ''
		this.label = options.label || ''
		this.description = options.description || ''
		this.options = options.options || []
		this.optionsDefault = options.optionsDefault || []
		this.restrictions = options.restrictions || []
		this.order = options.order === undefined ? 1 : options.order
		this.controlType = options.controlType || ''
		this.structureType = options.structureType || ''
		this.customBehaviour = options.customBehaviour || ''
		this.children = options.children || []
		this.deepNested = options.deepNested || ''
		this.placeholder = options.placeholder || ''
		this.floatlabel = options.floatlabel || ''
		this.type = options.type || ''
		this.mendatory = options.mendatory || false
		this.complementary = options.complementary || undefined
		this.observe = options.observe || false
		this.observe_champ = options.observe_champ || 0
		this.historique = options.historique || false
		this.readonly = options.readonly || false
		this.hideCreate= options.hideCreate || false
	}
}

@Injectable()
export class ForAtylInputBase {
	@Output() ready = new EventEmitter<any>()
	
	
	emitReadyEvent(ready:boolean=true,form:any=null) {
		let evt:any= {
			ready: ready,
			form: form
		}
		
		this.ready.emit(evt)
	}   
	      
}
